export default __webpack_public_path__ + "static/mobile-logo-a5f54b894461659cbc2d0b2036b2272d.png";